var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 15,
    viewBox: "0 0 14 15",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5580925 3.0176475 3.04926 3.04926c.2839494.28395033.4256305.68025109.3860604 1.07986251-.0395701.39961141-.256222.76042956-.5903454.98317749l-2.229555 1.4863725c-.277435.18495845-.4759721.4666824-.556845.7901625l-.9276075 3.7104225c-.0585593.2342389-.2385898.4188716-.4712763.4833237-.23268644.064452-.48205495-.0012411-.6527862-.1719687l-6.36825-6.36825c-.17072756-.17073125-.23642069-.42009976-.17196867-.65278623.06445202-.23268648.24908475-.41271702.48332367-.47127627l3.710415-.927615c.32348013-.0808729.60520405-.27940998.7901625-.556845l1.4863725-2.229555c.22274793-.33412338.5835661-.55077534.9831775-.59034541.3996114-.03957006.7959122.10211098 1.0798625.38606041z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 14.625 3.380873-3.380872",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.3719484c51d0e8e8a2dcb33b895e3014.svg";
export { ForwardRef as ReactComponent };